<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button id="help-btn-ticker-user-groups-get" type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>
  <div class="top-bar">
    <span class="page-header" *ngIf="userGroupName">{{ 'ticker:usergroups_usersInGroupHeader' | i18next : { defaultValue: 'Users in group' } }} <span class="header-details">{{ userGroupName }}</span></span>
    <span class="page-header" *ngIf="!userGroupName">{{'realtime:usergroups_allAgents' | i18next}}</span>

    <div class="right">
      <app-filter-input id="filter-input-ticker-user-groups-get" [(model)]="filter" (modelChange)="applyFilterFromProperty()"
      [placeholder]="'realtime:shared_lang_tableFilterLabel' | i18next" [width]="'350px'"></app-filter-input>
      <div class="toggleButtons" style="margin-left: 16px;">
        <button id="day-window-btn-ticker-user-groups-get" class="secondary-button" [class.active]="selectedWindow === 'day'" (click)="onSelectWindow('day')">
          {{ 'ticker:day' | i18next : { defaultValue: 'Day' } }}
        </button>
        <button id="week-window-btn-ticker-user-groups-get" class="secondary-button" [class.active]="selectedWindow === 'week'" (click)="onSelectWindow('week')">
          {{ 'ticker:week' | i18next : { defaultValue: 'Week' } }}
        </button>
      </div>
    </div>
  </div>
  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <!-- No-data template -->
    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 full-width-table">

      <!-- User Name -->
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="left nowrap">
          {{ 'ticker:usergroups_nameHead' | i18next : { defaultValue: 'Name' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="left nowrap">
          <!-- If you have a route for agent details and !hideAgentDetails, replace with routerLink -->
          <ng-container *ngIf="hideAgentDetails; else userLink">
            {{ r.valueName }}
          </ng-container>
          <ng-template #userLink>
            <a [routerLink]="['/real-time/ticker-agents/details', r.userId]"
               [queryParams]="{ groupName: userGroupName, type: type }">{{ r.valueName }}</a>
          </ng-template>
        </td>
        <td mat-footer-cell *matFooterCellDef class="left nowrap">
          {{ totals?.valueName || ('ticker:statistics_title' | i18next : { defaultValue: 'Totals' }) }}
        </td>
      </ng-container>

      <!-- Total Received -->
      <ng-container matColumnDef="totalReceived">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >
          {{ 'ticker:usergroups_totalReceivedHead' | i18next : { defaultValue: 'Total received' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ formatCell(r.totalReceived) }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ formatCell(totals?.totalReceived) }}
        </td>
      </ng-container>

      <!-- Total Answered -->
      <ng-container matColumnDef="totalAnswered">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >
          {{ 'ticker:usergroups_totalAnsweredHead' | i18next : { defaultValue: 'Total answered' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ formatCell(r.totalAnswered) }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ formatCell(totals?.totalAnswered) }}
        </td>
      </ng-container>

      <!-- Avg Survey Score (optional) -->
      <ng-container *ngIf="showSurveyScore" matColumnDef="avgSurveyScore">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_avgSurveyScore' | i18next : { defaultValue: 'Avg. survey score' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ formatCell(r.formattedAvgSurveyScore) }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ formatCell(totals?.formattedAvgSurveyScore) }}
        </td>
      </ng-container>

      <!-- Answer Rate -->
      <ng-container matColumnDef="answerRate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:usergroups_answerRateHead' | i18next : { defaultValue: 'Answer rate' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ formatCell(r.formattedAnswerRate) }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ formatCell(totals?.formattedAnswerRate) }}
        </td>
      </ng-container>

      <!-- Avg Speak Time -->
      <ng-container matColumnDef="avgSpeak">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_avgSpeakTime' | i18next : { defaultValue: 'Avg. speak time' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ formatCell(r.formattedSecondsAvgSpeak) }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ formatCell(totals?.formattedSecondsAvgSpeak, true) }}
        </td>
      </ng-container>

      <!-- Avg Wrapup Time -->
      <ng-container matColumnDef="avgWrapup">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_avgWrapupTime' | i18next : { defaultValue: 'Avg. wrap-up time' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ formatCell(r.formattedSecondsAvgWrapup) }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ formatCell(totals?.formattedSecondsAvgWrapup, true) }}
        </td>
      </ng-container>

      <!-- AHT -->
      <ng-container matColumnDef="aht">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:service_AHT' | i18next : { defaultValue: 'AHT' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ formatCell(r.formattedSecondsAHT) }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ formatCell(totals?.formattedSecondsAHT, true) }}
        </td>
      </ng-container>

      <!-- Time Logged In -->
      <ng-container matColumnDef="timeLoggedIn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:usergroups_timeLoggedInHead' | i18next : { defaultValue: 'Time logged in' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ formatCell(r.formattedSecondsLoggedIn) }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ formatCell(totals?.formattedSecondsLoggedIn, true) }}
        </td>
      </ng-container>

      <!-- Time In Pause -->
      <ng-container matColumnDef="timeInPause">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'ticker:usergroups_timeInPauseHead' | i18next : { defaultValue: 'Time in pause' } }}
        </th>
        <td mat-cell *matCellDef="let r" class="text-right">
          {{ formatCell(r.formattedSecondsInPause) }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right">
          {{ formatCell(totals?.formattedSecondsInPause, true) }}
        </td>
      </ng-container>

      <!-- header, rows, footer -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- No data row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>

      <tr mat-footer-row *matFooterRowDef="displayedFooterColumns" class="footer-row" [hidden]="dataSource.filteredData.length == 0"></tr>
    </table>
  </div>
</div>
